import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Select from "react-select";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import { HiOutlineTrash, HiPlus,HiX } from "react-icons/hi";
import { toast } from "react-toastify";

const RoomImage = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [newImage, setNewImage] = useState({
    ROOM_ID: "",
    LINK_ROOM_IMG: "",
    NO_URUT: "",
  });
  // Add this line to define previewImage and its setter
  const [previewImage, setPreviewImage] = useState(null);
  const [isAddModalOpen, setAddModalOpen] = useState(false);

  // Fetch property details
  const getDetailProperty = async (hid) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hid}`);
      if (response.status === 200) setPropData(response.data);
    } catch (err) {
      console.error("Error fetching property details:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch room list
  const getRoomSelect = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/select/rooms/type/${hotel_id}`);
      if (response.status === 200) setRoomList(response.data);
      // console.log(response.data)
    } catch (err) {
      console.error("Error fetching room list:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch room images
  const getImageList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/room/images/${hotel_id}`);
      if (response.status === 200) setImageList(response.data);
    } catch (err) {
      console.error("Error fetching image list:", err);
    } finally {
      setLoading(false);
    }
  };

  // Add new image
  const handleAddImage = async (e) => {
    e.preventDefault();
  
    try {
      const formData = new FormData();
      formData.append("UID", userData.id);
      formData.append("HOTEL_ID", hotel_id);
      formData.append("ROOM_ID", newImage.ROOM_ID);
      formData.append("LINK_ROOM_IMG", newImage.LINK_ROOM_IMG); // Append the file
      formData.append("NO_URUT", newImage.NO_URUT);
      
      const response = await axios.post(`/api/insert/room/image`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      if (response.status === 201) {
        toast.success("Image added successfully!");
        await getImageList();
        setNewImage({ ROOM_ID: "", LINK_ROOM_IMG: "", NO_URUT: "" });
        setPreviewImage(null);
        setAddModalOpen(false);
      } else {
        toast.error("Failed to add image.");
      }
    } catch (err) {
      console.error("Error adding image:", err);
      toast.error("An error occurred while adding the image.");
    }
  };
  

  // Delete image
  const handleDeleteImage = async (imageId) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        const response = await axios.get(`/api/delete/room/image/${imageId}`);
        if (response.status === 200) {
          toast.success("Image deleted successfully.");
          await getImageList(hotel_id);
        } else {
          toast.error("Failed to delete image.");
        }
      } catch (err) {
        console.error("Error deleting image:", err);
        toast.error("An error occurred while deleting the image.");
      }
    }
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRoomSelect();
      getImageList();
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-2 text-sm text-[#101827]">
             <span>Image Gallery</span> &gt; <span>{propData.NAME_HOTEL}</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            {isLoading ? (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0f1827] mb-4"></div>
                  <p className="text-gray-700">Load Data...</p>
                </div>
            </div>
            ) : imageList.length === 0 ? ( // Check if imageList is empty
              <p className="text-center text-sm text-gray-500">No Record. Please upload an first image.</p>
            ) : (
              imageList.map((room) => (
                <div key={room.room_id} className="mb-8 border p-6 bg-slate-100 rounded-md">
                  {/* Room Name */}
                  <h2 className="text-sm font-semibold mb-4 text-[#101827]">{room.room_name}</h2>
                  
                  {/* Image Gallery */}
                  {room.images.length === 0 ? ( // Check if room.images is empty
                    <p className="text-center text-gray-500">No Record. Please upload an image first.</p>
                  ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-5 gap-4">
                      {room.images.map((image, index) => (
                        <div key={index} className="relative group overflow-hidden">
                          {/* Image */}
                          <img
                            src={image.LINK_ROOM_IMG}
                            alt={`Room ${room.room_name}`}
                            className="w-full h-56 object-cover rounded-lg shadow-md transform transition-transform duration-300 group-hover:scale-110"
                          />

                          {/* NO_URUT Label */}
                          <span
                            className="absolute top-2 left-2 bg-blue-600 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md"
                            title={`Order: ${image.NO_URUT}`}
                          >
                            {image.NO_URUT}
                          </span>

                          {/* Delete Button */}
                          <button
                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition"
                            onClick={() => handleDeleteImage(image.ID_ROOM_IMG)}
                          >
                            <HiOutlineTrash size={20} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </section>

        </main>
      </div>

      <button
        className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition"
        onClick={() => setAddModalOpen(true)}
        title="Add Image"
      >
        <HiPlus size={24} />
      </button>

      {isAddModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
           
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-sm font-semibold">New Image {propData.NAME_HOTEL} </h4>
              <HiX 
                size={24} 
                onClick={() => setAddModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleAddImage}>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Room</label>
                <Select
                  options={roomList}
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  onChange={(e) => setNewImage({ ...newImage, ROOM_ID: e.value })}
                  placeholder="Select Room"
                  isClearable
                  className="text-xs"
                />
              </div>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Upload Image</label>
                {/* File Input */}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setNewImage({
                        ...newImage,
                        LINK_ROOM_IMG: file, // Store the file itself
                      });
                      setPreviewImage(URL.createObjectURL(file)); // Generate preview URL
                    }
                  }}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              {/* Image Preview */}
              {previewImage && (
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Image Preview</label>
                  <img
                    src={previewImage}
                    alt="Preview"
                    className="w-full h-40 object-cover rounded-md border text-xs"
                  />
                </div>
              )}
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Order Number</label>
                <input
                  type="number"
                  value={newImage.NO_URUT}
                  onChange={(e) => setNewImage({ ...newImage, NO_URUT: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-300 px-4 py-2 rounded mr-2 text-xs"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-white text-xs"
                >
                  Add Image
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default RoomImage;
